import React from 'react';
import { Text } from 'recharts';

// Axis tick label for the learning-result bar charts.
//
// Recharts (2.0.0-beta.1) gives every tick <Text> the axis width as `width`, which turns on
// word wrapping. When only that width changes (the chart is resized while mounted, e.g. the
// layout settles after switching lessons), Text.componentDidUpdate re-wraps the label
// without measuring its words, gets zero lines and renders an empty <text>, so the labels
// disappear. Dropping `width` keeps the label on one line and avoids that path.
//
// Usage: <XAxis tick={<AxisTick fill="black" fontSize={12} />} />. Recharts clones the
// element with the tick's position and payload.
export const AxisTick = ({ width, payload, ...props }) => (
  <Text {...props} className="recharts-cartesian-axis-tick-value">
    {payload?.value}
  </Text>
);

export default AxisTick;
